import { a0 as a } from "./country-d4e42059.js";
const e = a("ASSETS_BUCKET_URL"), s = `${e}/DefaultJobseekerAvatar.png`, t = `${e}/CloseIcon.svg`, n = `${e}/web.png`;
export {
  t as C,
  s as D,
  e as S,
  n as W
};
//# sourceMappingURL=index-510f96a1.js.map
